export const dataReducer = (state, {type, payload})=>{
    
   switch(type){
       case "Add_Category":
           //return  {...state, category:{...state.category,  payload}};
           return  {
               ...state, category:[...state.category,  ...payload]
           };      
       case "Add_Product":
           return{
               ...state, products:[...state.products, ...payload]
           };
       // case "Add_to_cart":
       //     return {...state, cartLength:cartLength+1, cart:[...state.cart, payload]};
       
       case "fetch_cart":
           return {...state, cart:[...payload], cartLength: payload?.reduce((acc,curr)=>acc+curr.qty,0)}
       
           case "fetch_wishlist":
           return {...state, wishlist:[...payload], wishlistLength: payload.length }

       case "logout":
           return {...state, cart:[], cartLength:0, wishlistLength:0, wishlist:[], isLoggedIn:false }

       case "show_btn":
           return {...state, activeFilterCategory:[]};

       case "Filter-Categories":
           return{
               ...state, activeFilterCategory: [`${payload}`]
           }
       
       case "add_filter_category":
           return {...state, activeFilterCategory:[...state.activeFilterCategory, payload]}

       case "delete_filter_category":
           return{...state, activeFilterCategory: [...state.activeFilterCategory.filter((cate)=> cate !== payload)]
           }

       case "filterPrice":
           return{
               ...state,  priceRange: payload
           }
       case "filterRating":
           return{...state, rating: payload}
       
       case "filterSortBy":
           return{...state, sortBy: payload}

       case "clearFilters":
           return{...state, 
           sortBy: "",
           priceRange: 1500,
           rating: 0,
           activeFilterCategory:[],    
       }
       case "handleCart":
           return{
               ...state, cart:[...payload], cartLength: payload?.reduce((acc,curr)=>acc+curr.qty,0)
           }
   
       case "handleWishlist":
           return{... state, wishlist:[...payload], wishlistLength: payload.length  } 

       case "add-address":
           return {...state, address:[...payload]}
       
       case "editAddress":{
               return {...state, address:[ ...payload]}
       }
       case "update-address":
           return{
               ...state, address:[...state.address, payload]
           }
       case "HandleSearch":
        return{
            ...state,search:payload
        }
       default:
           return state;
   }
   
}